export default import.meta.ROLLDOWN_FILE_URL_A3gtZ7mddHjILs2gEmqIOQ